import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useCartStore = create()(persist((set)=>({
        items: [],
        throbKey: 0,
        addItem: (item)=>set((state)=>{
                const existing = state.items.find((i)=>i.productId === item.productId);
                if (existing) {
                    return {
                        throbKey: state.throbKey + 1,
                        items: state.items.map((i)=>i.productId === item.productId ? {
                                ...i,
                                quantity: i.quantity + item.quantity
                            } : i)
                    };
                }
                return {
                    throbKey: state.throbKey + 1,
                    items: [
                        ...state.items,
                        item
                    ]
                };
            }),
        removeItem: (productId)=>set((state)=>({
                    items: state.items.filter((i)=>i.productId !== productId)
                })),
        updateQuantity: (productId, quantity)=>set((state)=>({
                    items: quantity <= 0 ? state.items.filter((i)=>i.productId !== productId) : state.items.map((i)=>i.productId === productId ? {
                            ...i,
                            quantity
                        } : i)
                })),
        clearCart: ()=>set({
                items: []
            })
    }), {
    name: 'elevated-cart'
}));
export const selectCartTotal = (state)=>state.items.reduce((sum, item)=>sum + item.priceCents * item.quantity, 0);
export const selectCartCount = (state)=>state.items.reduce((sum, item)=>sum + item.quantity, 0);
